<template>
  <div :class="$style.container">
    <div :class="$style.preview">
      <base-icon
        v-p-t="4"
        v-color:black-2
        name="basic_list"
      />
    </div>
    <div :class="$style.content">
      <div
        v-m-b="10"
        :class="$style.title"
        v-text="$t('bill.description')"
      />
      <div v-if="splitedDescription" :class="$style.description">
        <p
          v-for="(description, idx) in splitedDescription"
          :key="idx"
          v-text="description"
        />
      </div>
      <template v-if="isShownTildaParams">
        <div v-m-t="10" :class="$style.description">
          <p
            v-for="(value, name) in tildaCustomFields"
            :key="name"
            v-text="`${name} - ${value}`"
          ></p>
        </div>
        <div v-m-t="10" :class="$style.description">
          <p
            v-for="(value, idx) in tildaProducts"
            :key="idx"
            v-text="value"
          ></p>
        </div>
        <div
          v-if="tildaAddationalString"
          v-m-t="10"
          :class="$style.description"
          v-text="tildaAddationalString"
        ></div>
      </template>
    </div>
  </div>
</template>

<script>
import TildaParamsService from 'services/tilda';

export default {
  name: 'TransactionDescription',
  props: {
    description: String,
    additionalParams: String,
  },
  computed: {
    splitedDescription() {
      if (this.$validate.isNotString(this.description)) {
        return null;
      }

      return this.description.split('\n');
    },
    isShownTildaParams() {
      return TildaParamsService.checkTildaOrderId(this.additionalParams);
    },
    tildaParams() {
      return TildaParamsService.getTildaParams(this.additionalParams);
    },
    tildaCustomFields() {
      return this.tildaParams.details.customFields;
    },
    tildaProducts() {
      const { products } = this.tildaParams.details;

      return products.map(product => {
        const quantity = product.quantity > 1 ? ` x ${product.quantity}` : '';

        return `${product.name} - ${product.price} ₽${quantity}`;
      });
    },
    tildaAddationalString() {
      const { details } = this.tildaParams;
      const values = [details?.name, details?.email, details?.phone]
        .filter(i => i);

      return values.join(', ');
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +flexbox
    word-break: break-all

  .preview
    +flexbox
    +align-self(flex-start)
    flex: none
    margin-right: 26px

  .content
    flex: 1

  .title
    +font-type('medium', 12, 20)
    color: #212121
    opacity: .5

  .description
    +font-type('medium', 12, 18)
    color: #212121
</style>
